module.exports = __webpack_public_path__ + "img/face_shape_female_extra_heart_mask.66ebe828.png";